var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoAccountVerified = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16.004,
    viewBox: "0 0 18 16.004",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico_account_verified",
    d: "M243.545,816.931a3.549,3.549,0,1,1-3.39,3.545,3.47,3.47,0,0,1,3.39-3.545Zm1.479,11.135a5.41,5.41,0,0,1,1.167-3.364.976.976,0,0,0-.52.2,3.281,3.281,0,0,1-4.217-.02.927.927,0,0,0-.809-.189,6.173,6.173,0,0,0-3.73,5.339c-.092.833.346,2.864,6.613,2.894a16.689,16.689,0,0,0,3.886-.361,5.446,5.446,0,0,1-2.39-4.5Zm5.436,4.446a4.449,4.449,0,1,1,4.445-4.449,4.449,4.449,0,0,1-4.445,4.449Zm-2.46-5.2a.262.262,0,0,0-.181.073l-.542.545a.26.26,0,0,0,0,.359l2.272,2.29a.249.249,0,0,0,.178.075.274.274,0,0,0,.184-.075l3.735-3.735a.26.26,0,0,0,0-.362l-.546-.542a.25.25,0,0,0-.18-.076.253.253,0,0,0-.182.076l-3.007,3.007-1.549-1.561a.268.268,0,0,0-.182-.072Z",
    transform: "translate(-236.905 -816.927)",
    fill: "#8d939c"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoAccountVerified);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_account_verified.3c1d6a46b7c77788a9f5adc5897980fa.svg";